
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Company from "../pages/company/page";
import Careers from "../pages/careers/page";
import Blog from "../pages/blog/page";
import Services from "../pages/services/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/careers",
    element: <Careers />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
